import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { Layout } from "../../ui/layout";
import { ButtonComponent } from "../../ui/molecules/button/newButton";
import { Calendar } from "../../ui/molecules/calendar";
import { MadfarmInput } from "../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { Pagination } from "../../ui/organisms/pagination";
import { SuccessPopup } from "../../ui/organisms/successPopup";
import { normativa, trainingActivityOptions } from "../../utils";
import { BoxFormazione } from "./boxFormazione/boxFormazione";
import { GetAllTraining, resetGetAllTrainingFilters, setGetAllTrainingFiltersDate, setGetAllTrainingFiltersNorm, setGetAllTrainingFiltersPage, setGetAllTrainingFiltersParticipant, setGetAllTrainingFiltersType } from "./boxFormazione/slice";

export function Formazione() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const trainingState = useAppSelector(state => state.PMTraining)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [showDeleteSuccess, setShowDeleteSuccess] = useState<boolean>(false)

    useEffect(() => {
        if (
            trainingState.trainingCreationStatus === 'successfully' ||
            trainingState.trainingUpdateStatus === 'successfully'
        ) {
            setShowSuccess(true)
        }
    }, [trainingState.trainingCreationStatus,
    trainingState.trainingUpdateStatus
    ])

    useEffect(() => {
        if (trainingState.trainingDeleteStatus === 'successfully') {
            setShowDeleteSuccess(true)
        }
    }, [trainingState.trainingDeleteStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
        if (showDeleteSuccess) {
            setTimeout(() => {
                setShowDeleteSuccess(false)
            }, 2000)
        }
    }, [showSuccess, showDeleteSuccess])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_PERSONALE}
            breadcrumbItems={['Formazione dipendenti', 'Formazione']}
            noPaddingLat
            headerLabel="Formazione dipendenti"
            headerChildren={
                <div className="flex items-center h-full w-full justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Aggiungi Formazione"
                        color={"orange"}
                        onClick={() => {
                            navigate('/nuovoFormazione')
                        }}
                    />
                </div>
            }
        >
            <div className="p-6 flex flex-col min-w-0">
                <div className="rounded-xl border border-neutral-200">
                    <div className="flex flex-col xl:flex-row xl:items-end gap-3">
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-[minmax(240px,1.2fr)_minmax(180px,1fr)_minmax(180px,1fr)_minmax(220px,1fr)] gap-2 flex-1">
                            <MadfarmInput
                                placeholder="Cerca partecipante"
                                value={trainingState.getAllTrainingFilters.participant ?? ''}
                                onChangeText={(text) =>
                                    dispatch(setGetAllTrainingFiltersParticipant(text))
                                }
                            />
                            <Calendar
                                selected={trainingState.getAllTrainingFilters.date}
                                onChange={(date) => {
                                    if (!date) {
                                        dispatch(setGetAllTrainingFiltersDate(''))
                                        return
                                    }
                                    dispatch(setGetAllTrainingFiltersDate(format(new Date(date), 'yyyy-MM-dd')))
                                }}
                            />
                            <MadfarmStaticSelect
                                isClearable
                                noOptionsMessage="Nessuna tipologia trovata"
                                placeholder={'Tipologia'}
                                options={trainingActivityOptions}
                                value={trainingState.getAllTrainingFilters.type ?? null}
                                onChange={(value) => {
                                    // @ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setGetAllTrainingFiltersType(newValue ?? ''))
                                }}
                            />
                            <MadfarmStaticSelect
                                isClearable
                                noOptionsMessage="Nessuna norma trovata"
                                placeholder={'Norma di riferimento'}
                                options={normativa}
                                value={trainingState.getAllTrainingFilters.norm ?? null}
                                onChange={(value) => {
                                    // @ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setGetAllTrainingFiltersNorm(newValue ?? ''))
                                }}
                            />
                        </div>
                        <div className="flex gap-2 xl:justify-end">
                            <ButtonComponent
                                size={"lg"}
                                iconPosition={"off"}
                                variant={"outline"}
                                label="Pulisci"
                                color={"gray"}
                                onClick={() => {
                                    dispatch(resetGetAllTrainingFilters())
                                    dispatch(setGetAllTrainingFiltersPage(0))
                                    dispatch(GetAllTraining({ itemsPerPage: 30, page: 0, participant: '' }))
                                }}
                            />
                            <ButtonComponent
                                size={"lg"}
                                iconPosition={"off"}
                                variant={"outline"}
                                label="Cerca"
                                color={"orange"}
                                onClick={() => {
                                    dispatch(setGetAllTrainingFiltersPage(0))
                                    dispatch(GetAllTraining({ ...trainingState.getAllTrainingFilters, page: 0 }))
                                }}
                            />
                        </div>
                    </div>
                </div>
                <Pagination
                    numbResults={trainingState.getAllTrainingsResponse?.total || 0}
                    pages={trainingState.getAllTrainingsResponse?.totalPage || 1}
                    currentPage={trainingState.getAllTrainingFilters.page || 0}
                    setPage={(page) => {
                        dispatch(setGetAllTrainingFiltersPage(page))
                        dispatch(GetAllTraining({ ...trainingState.getAllTrainingFilters, page }))
                    }}
                />
                {
                    (showSuccess || showDeleteSuccess) &&
                    <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                        <SuccessPopup
                            active={showSuccess || showDeleteSuccess}
                            message="Dati salvati correttamente."
                            onClose={() => {
                                setShowSuccess(false)
                                setShowDeleteSuccess(false)
                            }}
                        />
                    </div>
                }
                <BoxFormazione />
            </div>

        </Layout>
    )
}